export default "__VITE_ASSET__eQRLYOAJ__"